var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.enforceShowLoader)?_c('div',{style:({ height: _vm.iframeHeight })},[_c('Preloader')],1):[_c('iframe',{staticClass:"iframe",style:({
        height: _vm.iframeHeight
      }),attrs:{"src":_vm.computedUrl,"type":"application/pdf"},on:{"load":function($event){_vm.isDocumentLoading = false}}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }